<nav class="navbar navbar-expand-lg mt-1">
  <div class="container-fluid">
    <a class="navbar-brand d-flex justify-content-center" (click)="goBack()">
      <img id="logo_neocredito" class="img-fluid ms-lg-5" src="assets/img/logo.svg" alt="Logo neocredito">
    </a>
  </div>
</nav>
